import React from "react";
import { Play, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EmpowerYourLocalBusiness() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="25363" id="rehab-delivered-to-your-door" className="dark bg-background text-foreground relative overflow-hidden py-20 lg:py-32">
      {}
      <style>{`
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
          100% { transform: translateY(0px); }
        }
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
      `}</style>

      {}
      <div className="absolute top-0 right-0 -mt-20 -mr-20 w-96 h-96 bg-[#466dad]/20 rounded-lg blur-3xl opacity-50 pointer-events-none" />
      <div className="absolute bottom-0 left-0 -mb-20 -ml-20 w-72 h-72 bg-[#3b456e]/10 rounded-lg blur-3xl opacity-30 pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div ref={textRef} className={`flex flex-col items-start space-y-8 transition-all duration-1000 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="space-y-4">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-sans tracking-tight leading-tight text-white">
                Rehab.{" "}
                <span className="text-[#51b7f5]">
                  Delivered
                </span>{" "}
                to Your Door.
              </h1>
              <p className="text-lg md:text-xl text-muted-foreground max-w-lg leading-relaxed font-sans">
                High-performance physical therapy for athletes and active adults in Monmouth County. 
                No travel, no waiting, just 1-on-1 expert care.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <Button asChild size="lg" className="bg-[#51b7f5] text-white hover:bg-[#51b7f5]/90 shadow-lg shadow-[#51b7f5]/20 text-base font-semibold px-8 h-12 rounded-md">
                <Link to="/ContactPage">
                  Schedule a Discovery Call
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              
              <Button asChild variant="ghost" size="lg" className="text-white hover:text-white hover:bg-white/10 border border-white/10 h-12 px-8 rounded-md">
                <Link to="/OurStoryPage">
                  Our Story
                </Link>
              </Button>
            </div>

            
          </div>

          {}
          <div ref={imageRef} className={`relative transition-all duration-1000 delay-200 ease-out ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            <div className="relative w-full animate-float">
              <AspectRatio ratio={16 / 9}>
                  <img src="https://ruling-egret.10web.cloud/wp-content/uploads/2026/04/Triathlete-Recovery.png" alt="High-performance athlete training on the Monmouth County coast with mobile physical therapy support" className="object-cover w-full h-full" />
                  
                  {}
                  <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent" />
                  
                  {}
                  <div className="absolute bottom-6 left-6 right-6 bg-card/90 backdrop-blur-md border border-white/10 p-4 rounded-xl shadow-lg flex items-center justify-between">
                    <div>
                      <p className="text-xs text-muted-foreground font-medium uppercase tracking-wider">Recovery Progress</p>
                      <div className="flex items-baseline gap-2 mt-1">
                        <span className="text-2xl font-bold text-white">+85%</span>
                        <span className="text-xs text-[#51b7f5] font-medium">↑ Peak Performance</span>
                      </div>
                    </div>
                    <div className="h-10 w-24 flex items-end gap-1">
                        {[40, 65, 45, 80, 55, 90].map((h, i) => <div key={i} data-index={i} style={{
                    height: `${h}%`
                  }} className="flex-1 bg-[#466dad] rounded-t-sm opacity-80" />)}
                    </div>
                  </div>
                </AspectRatio>
            </div>
          </div>

        </div>
      </div>
    </section>;
}